import { render, staticRenderFns } from "./Graduates.vue?vue&type=template&id=4e511fbc&scoped=true&"
import script from "./Graduates.vue?vue&type=script&lang=js&"
export * from "./Graduates.vue?vue&type=script&lang=js&"
import style0 from "./Graduates.vue?vue&type=style&index=0&id=4e511fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e511fbc",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIReviewsAlt: require('/opt/build/repo/components/UI/ReviewsAlt.vue').default})
